import React from 'react';
import { Layout, ThumbnailSize } from '../../types/viewComposition';
import '../../styles/components/itemGrid.css';

interface ItemGridProps {
  layout: Layout;
  size?: ThumbnailSize;
  children: React.ReactNode;
}

export const ItemGrid: React.FC<ItemGridProps> = ({ layout, size, children }) => {
  // Map layout to CSS class
  // Layout values: 'list', 'small', 'medium', 'large'
  // CSS classes: 'item-grid-list', 'item-grid-small', 'item-grid-medium', 'item-grid-large'
  let gridClass = `item-grid item-grid-${layout}`;
  
  // Add x-large modifier for single column layout
  if (size === 'x-large') {
    gridClass += ' item-grid-xlarge';
  }

  return (
    <div className={gridClass}>
      {children}
    </div>
  );
};
